// [MODULE_ACTIONS] EXPORT ACTION
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

const commonActions = {
    // [MODULE_ACTIONS] DEFINE NEW ACTIONS
    toggleSideBar: () => ({type: TOGGLE_SIDEBAR}),
};

export default commonActions;
